import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ScrollTriggerをGSAPに登録
gsap.registerPlugin(ScrollTrigger);

export function fadeInSelf() {
  const fadeInItems = document.querySelectorAll(".js-fade-in-self");

  if (!fadeInItems.length) return;

  fadeInItems.forEach((item) => {
    const check = item.querySelector(".c-check");

    // 初期状態
    gsap.set(item, {
      opacity: 0,
      visibility: "hidden",
      y: 40,
    });

    if (check) {
      check.classList.remove("is-active");
    }

    // Timeline + ScrollTrigger
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: item,
        start: "top 80%",
        once: true,
      },
    });

    // ① フェードイン
    tl.to(item, {
      opacity: 1,
      visibility: "visible",
      y: 0,
      duration: 0.4,
      ease: "sine.inOut",
    });

    // ② 子要素 c-check の背景アニメ
    if (check) {
      tl.add(() => {
        check.classList.add("is-active");
      }, "-=0.2"); // 少し重ねる（0 にすれば完全後）
    }
  });
}
